import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Breadcrumb as AntBreadcrumb } from 'antd';
import styled from 'styled-components';

const Breadcrumb = styled(AntBreadcrumb)`
  span {
    color: var(--text-primary);

    &.ai {
      color: var(--dark-blue);
      cursor: pointer;
    }
  }
`;

interface RecommendationBreadcrumbProps {
  company: string;
}

const RecommendationBreadcrumb = ({ company }: RecommendationBreadcrumbProps) => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <Breadcrumb
      items={[
        { title: 'Company' },
        { title: company },
        {
          className: 'ai',
          title: 'AI Insights',
          onClick: goBack,
        },
      ]}
      separator="·"
    />
  );
};

export default RecommendationBreadcrumb;
